if (!customElements.get('product-info')) {
  customElements.define(
    'product-card',
    class ProductCard extends HTMLElement {
      constructor() {
        super();
        // read dataset section-id and product-id
        this.sectionId = this.dataset.sectionId;
        this.productId = this.dataset.productId;
        this.uniqueVariantIds = this.dataset.uniqueVariantIds.split(',');
        this.mainLink = this.querySelector(`#CardLink-${this.sectionId}-${this.productId}`);
      }

      connectedCallback() {
        this.mainImage = this.querySelector(`#main-image-${this.sectionId}-${this.productId}`);
        // find all divs with id "variant-select-{{ section_id }}-{{ card_product.id }}-{{ matching_variant.id }}"
        this.variantSelects = this.uniqueVariantIds.map((variantId) =>
          this.querySelector(`#variant-select-${this.sectionId}-${this.productId}-${variantId}`),
        );

        // add click listener to every variant select
        this.variantSelects.forEach((variantSelect) => {
          variantSelect?.addEventListener('click', this.onVariantSelectInteraction.bind(this));
          // add hover listener to every variant select
          variantSelect?.addEventListener('mouseenter', this.onVariantSelectInteraction.bind(this));
          variantSelect?.addEventListener('mouseleave', this.onVariantSelectLeave.bind(this));
        });
      }

      disconnectedCallback() {
        // remove click listener from every variant select
        this.variantSelects.forEach((variantSelect) => {
          variantSelect?.removeEventListener('click', this.onVariantSelectInteraction.bind(this));
          variantSelect?.removeEventListener('mouseenter', this.onVariantSelectInteraction.bind(this));
          variantSelect?.removeEventListener('mouseleave', this.onVariantSelectLeave.bind(this));
        });
      }

      onVariantSelectInteraction(evt) {
        // get variant id from dataset
        const variantId = evt.currentTarget.dataset.variantId;
        const imageUrl = evt.currentTarget.dataset.imageUrl;
        const srcset = evt.currentTarget.dataset.srcset;
        const variantUrl = evt.currentTarget.dataset.variantUrl;

        // set main image src to variant image url
        this.mainImage.src = `https:${imageUrl}`;
        this.mainImage.srcset = srcset;

        // set main link href to variant url
        this.mainLink.href = variantUrl;

        // remove active class from all variant selects
        this.variantSelects.forEach((variantSelect) => {
          variantSelect !== null && variantSelect.classList.remove('color-variant__selected');
        });

        // add active class to clicked variant select
        evt.currentTarget.classList.add('color-variant__selected');
      }

      onVariantSelectLeave(evt) {
        // remove active class from hovered variant select
        evt.currentTarget.classList.remove('color-variant__selected');
      }
    },
  );
}
